import React, { useState } from "react";
import "./projectCard.css";

const ProjectsCard = ({
  image,
  title,
  description,
  productOverview,
  category,
  projectLink,
}) => {
  const [isReadMore, setIsReadMore] = useState(true);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const TextWithLineBreaks = (text) => {
    const textArray = text.split("//").map((line) => line.trim());
    return (
      <ul>
        {textArray.map((eachOne) => (
          <li className="each-sub-item" key={eachOne}>
            {eachOne}
          </li>
        ))}
      </ul>
    );
  };

  const CreateLiItem = (eachOne, lengthOfTitle) => (
    <span>
      <span className="project-span">{eachOne.slice(0, lengthOfTitle)}</span>
      {/* {eachOne.slice(lengthOfTitle, eachOne.length)} */}
      {eachOne.slice(lengthOfTitle, eachOne.length).includes("//")
        ? TextWithLineBreaks(eachOne.slice(lengthOfTitle, eachOne.length))
        : eachOne.slice(lengthOfTitle, eachOne.length)}
    </span>
  );

  const FindTheSideHeading = (eachOne) => {
    if (eachOne.includes("Notices and Updates:")) {
      return CreateLiItem(eachOne, "Notices and Updates:".length);
    } else if (eachOne.includes("Results with Grade Points:")) {
      return CreateLiItem(eachOne, "Results with Grade Points:".length);
    } else if (eachOne.includes("Assignments & Material PDFs:")) {
      return CreateLiItem(eachOne, "Assignments & Material PDFs:".length);
    } else if (eachOne.includes("Important Exam Questions:")) {
      return CreateLiItem(eachOne, "Important Exam Questions:".length);
    } else if (eachOne.includes("Hall Ticket Number Finder:")) {
      return CreateLiItem(eachOne, "Hall Ticket Number Finder:".length);
    } else if (eachOne.includes("Pass/Fail Data Analysis:")) {
      return CreateLiItem(eachOne, "Pass/Fail Data Analysis:".length);
    } else if (eachOne.includes("NASA APOD Integration:")) {
      return CreateLiItem(eachOne, "NASA APOD Integration:".length);
    } else if (eachOne.includes("Traffic Monitoring:")) {
      return CreateLiItem(eachOne, "Traffic Monitoring:".length);
    } else if (eachOne.includes("Technologies used:")) {
      return CreateLiItem(eachOne, "Technologies used:".length);
    } else if (eachOne.includes("Authentication System:")) {
      return CreateLiItem(eachOne, "Authentication System:".length);
    } else if (eachOne.includes("Login Route:")) {
      return CreateLiItem(eachOne, "Login Route:".length);
    } else if (eachOne.includes("Home Route:")) {
      return CreateLiItem(eachOne, "Home Route:".length);
    } else if (eachOne.includes("Jobs Route:")) {
      return CreateLiItem(eachOne, "Jobs Route:".length);
    } else if (eachOne.includes("Job Item Details Route:")) {
      return CreateLiItem(eachOne, "Job Item Details Route:".length);
    } else if (eachOne.includes("Not Found Route:")) {
      return CreateLiItem(eachOne, "Not Found Route:".length);
    } else if (eachOne.includes("Header Navigation:")) {
      return CreateLiItem(eachOne, "Header Navigation:".length);
    } else if (eachOne.includes("Dynamic Filtering:")) {
      return CreateLiItem(eachOne, "Dynamic Filtering:".length);
    } else if (eachOne.includes("Role:")) {
      return CreateLiItem(eachOne, "Role:".length);
    } else {
      return eachOne;
    }
  };

  return (
    <div className="w-full py-8 flex flex-col justify-center items-center border-b-[1px] border-b-zinc-800">
      <a href={projectLink} target="_blank" rel="noreferrer">
        <div className="w-full h-full mb-3 overflow-hidden relative cursor-pointer group">
          <img
            className="w-full h-full object-cover scale-100 group-hover:scale-110 duration-300 cursor-pointer"
            src={image}
            alt="ImageOne"
          />
          <div className="w-full h-full absolute top-0 left-0 hover:bg-gradient-to-r from-green-600 via-green-600 to-green-200 opacity-20"></div>
        </div>
      </a>
      <h3 className="font-titleFont text-lg font-semibold text-[#ccc]">
        {title}
      </h3>
      <p className="text-base text-gray-400 -mt-1">{category} </p>

      <p className="text-sm mb-2">
        {isReadMore ? description.slice(0, 30) + "..." : description}
      </p>
      {!isReadMore && (
        <ul>
          {productOverview.map((eachOne) => (
            <li className="each-item" key={eachOne}>
              {FindTheSideHeading(eachOne)}
            </li>
          ))}
        </ul>
      )}
      <button
        onClick={toggleReadMore}
        className="btn btn-link text-sm text-blue-400"
      >
        {isReadMore ? "Read More" : "Read Less"}
      </button>
    </div>
  );
};

export default ProjectsCard;
